import * as Msal from "msal"

export const adLogout = (removeCookie, setState) => {
  const msalConfig = {
    navigateToLoginRequestUrl: false,
    auth: {
      clientId: process.env.AD_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${process.env.AD_TENANT_ID}`,
      redirectUri: process.env.AD_LOGIN_REDIRECT,
      // navigateToLoginRequestUrl: false
    },
  }

  const msalInstance =
    typeof window !== "undefined" && new Msal.UserAgentApplication(msalConfig)

  setState({
    authenticated: false,
    message: {
      text: "",
      variant: "",
    },
    user: {
      username: "",
      userId: "",
      roleId: "",
    },
    employeeDetails: {
      employeeId: 0,
      employeeName: "",
      employeeNumber: 0,
      employeeNameNumber: "",
    },
    rules: [],
    loading: false,
    aliased: false,
    isAdUser: false,
    position: {},
  })
  msalInstance.logout()
  removeCookie("hallenToken", { path: "/" })
}
